// extracted by mini-css-extract-plugin
export default {"dragWrapper":"index-module__YBYr8","isDragging":"index-module__y8qYb","dragIcon":"index-module__O6wuu","projectName":"index-module__GeqcW","noDragging":"index-module__SkcEj"};